import {
  Box,
  Flex,
  HStack,
  Image,
  Stack,
  StackDivider,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { BiEdit } from "react-icons/bi";
export default function Certifications() {
  return (
    <Box border="1px solid #c5c5c5" borderRadius={10} overflow="hidden" my={8}>
      <Flex
        bg="#f1f1f1"
        justifyContent="space-between"
        p={4}
        fontWeight="medium"
        borderBottom={"1px"}
        borderColor="#c5c5c5"
      >
        <Text fontSize={{ base: "18px", md: "22px" }}>Certifications</Text>
      </Flex>
      <Stack divider={<StackDivider />} px={{base:1,sm:6}}>
        <Box py={{base:5,md:10}}>
          <Flex gap={{base:2,sm:4}} alignItems="start" >
            <Image src="/images/freelancer/dashboard/certification.png" w={{base:"60px",sm:"120px"}} />
            <Flex gap={2} fontWeight={"medium"} mb={3} alignItems="start" w="full" justifyContent={"space-between"}>
              <Stack >
                <Text
                  color="black"
                  fontSize={{ base: "14px",md:"19px", lg: "26px" }}
                  fontWeight="medium"
                >
                  Logo Design Pro
                </Text>
                <Text
                  fontWeight={"medium"}
                  color="#888"
                  fontSize={{ base: "10px",md:"14px", xl: "20px" }}
                >
                  <b style={{ color: "black" }}>Provider: </b>American Marketing
                  Association (AMA) + Digital Marketing Institute <br />
                  <b style={{ color: "black" }}>Issued: </b>June 2022
                  <br />
                  <b style={{ color: "black" }}>Certification ID:</b> Google UX
                  Design
                </Text>
              </Stack>
              <HStack
                alignItems="center"
                gap={1}
                color="brand.500"
                cursor="pointer"
                display={{base:"none",sm:"flex"}}
              
              >
                <Text>Edit</Text>
                <BiEdit />
              </HStack>
            </Flex>
          </Flex>
          {/* <HStack
                alignItems="center"
                gap={1}
                color="brand.500"
                cursor="pointer"
                display={{base:"flex",sm:"none"}}
              >
                <Text>Edit</Text>
                <BiEdit />
              </HStack> */}
        </Box>
        <Box py={{base:5,md:10}}>
          <Flex gap={{base:2,sm:4}}  alignItems="start">
            <Image src="/images/freelancer/dashboard/certification.png"  w={{base:"60px",sm:"120px"}} />
            <Flex gap={10} fontWeight={"medium"} mb={3} alignItems="start" w="full" justifyContent={"space-between"}>
              <Stack>
                <Text
                  color="black"
                  fontSize={{ base: "14px",md:"19px", lg: "26px" }}
                  fontWeight="medium"
                >
                  Logo Design Pro
                </Text>
                <Text
                  fontWeight={"medium"}
                  color="#888"
                  fontSize={{ base: "10px",md:"14px", xl: "20px" }}
                >
                  <b style={{ color: "black" }}>Provider: </b>American Marketing
                  Association (AMA) + Digital Marketing Institute <br />
                  <b>Issued: </b>June 2022
                  <br />
                  <b>Certification ID:</b> Google UX Design
                </Text>
              </Stack>
              <HStack
                alignItems="center"
                gap={1}
                color="brand.500"
                cursor="pointer"
                display={{base:"none",sm:"flex"}}
              >
                <Text>Edit</Text>
                <BiEdit />
              </HStack>
            </Flex>
          </Flex>
          {/* <HStack
                alignItems="center"
                gap={1}
                color="brand.500"
                cursor="pointer"
                display={{base:"flex",sm:"none"}}
              >
                <Text>Edit</Text>
                <BiEdit />
              </HStack> */}
        </Box>
      </Stack>
    </Box>
  );
}
